import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getTextFormats } from '../utils/urls';

import { TextQuestionFormatResult } from 'types/questions';
import { ErrorModal } from 'types/modalTypes';

async function fetchTextFormats(): Promise<APIResult> {
  const response = await fetch(getTextFormats, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<TextQuestionFormatResult>;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetTextFormats(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_text_formats',
    async () => {
      const fetchResponse = await fetchTextFormats();
      const result = fetchResponse.Data.map(item => ({
        id: item.Id,
        name: item.Description,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetTextFormats };
